import React, { useState } from "react";
import { Menu, Dropdown, Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import LoadingSkeleton from "../loading-sekeleton/LoadingSkeleton";
import { COLORS, Typo } from "../../../../../../layout/theme";
import {
	ActionButton,
	AntdTable,
	ColorState,
	Container,
	Section,
	StateContainer,
	TableContainer,
} from "./styles";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdComputer } from "react-icons/md";
import { BiMobile } from "react-icons/bi";
import { numberWithDotAndCommas } from "../../../../../../../utils/numberWithDotAndComas";
import moment from "moment";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../../../utils/notificationToast";
import { useCart } from "../../../../../../../contexts/cartContext";
import { FiPhoneCall } from "react-icons/fi";
import { FaHeadset } from "react-icons/fa";
import { AiOutlineAudit } from "react-icons/ai";

const { confirm } = Modal;

export default function MyBuysDateTable({ data, loading }) {
	const [key, setKey] = useState(null);
	const [modalInfo, setModalInfo] = useState(null);
	const navigate = useNavigate();

	const { addProdsToCart } = useCart();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const showModal = (r) => {
		setIsModalOpen(true);
		setModalInfo(r);
	};
	const handleOk = () => {
		setIsModalOpen(false);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const handleReBuy = () => {
		confirm({
			title: `¿Seguro que quiere rehacer esta orden?`,
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "Los productos habilitados se agregaran al carrito.",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				handleAction();
			},
		});
	};

	const handleAction = async () => {
		const postData = key.items
			.filter((i) => i.comboId === null)
			.map((o) => ({
				id: o.productId,
				quantity: o.quantity,
				paused: o.product.paused,
				draft: o.product.draft,
				deleted: o.product.deleted,
				fromOrder: true,
			}));
		const res = await addProdsToCart(postData);
		openNotificationWithIcon(
			TYPE.SUCCESS,
			"Productos agregados al carrito con exito",
			"Los productos se agregaron al carrito con exito",
		);
		if (res) navigate("/cart");
	};

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/compras/${key?.id}`}>
							<Typo type="secondary">Ver detalle</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: (
						// <Link to={`/admin/compras/${key}`}>
						<Typo onClick={() => handleReBuy()}>Volver a comprar</Typo>
						// </Link>
					),
				},
			]}
		/>
	);

	const columns = [
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						N° TRF
					</div>
				);
			},
			width: 120,
			dataIndex: "orderNumId",
			render: (f, r) => (
				<Section>
					<Container cursor="pointer" onMouseOver={() => setKey(r?.id)}>
						<Link to={`/admin/compras/${key}`}>
							<Typo type="primary" fontWeight={600} fontSize={14}>
								{f}
							</Typo>
						</Link>
					</Container>
					<Typo type="mediumGrey" fontWeight={500} fontSize={13}>
						{moment(r.created).format("DD/MM/YYYY")}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						USUARIO
					</div>
				);
			},
			dataIndex: "userFrom",
			render: (f, r) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo
						type="darkGrey"
						fontWeight={600}
						fontSize={14}
						onClick={() => showModal(r)}
						style={{ cursor: "pointer" }}
					>
						{f === "web" ? (
							<MdComputer />
						) : f === "expoSeller" ? (
							<AiOutlineAudit />
						) : f === "webSeller" ? (
							<FaHeadset />
						) : f === "mobile" ? (
							<>
								<BiMobile />{" "}
								<Typo type="darkGrey" fontWeight={600} fontSize={12}>
									App
								</Typo>
							</>
						) : (
							<FiPhoneCall />
						)}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						LABORATORIO
					</div>
				);
			},
			dataIndex: "laboratoryName",
			render: (value, record) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{value}
				</Typo>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ITEMS
					</div>
				);
			},
			dataIndex: "quantityItems",
			render: (f) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="darkMuted" fontWeight={600} fontSize={14}>
						{f}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "end",
						}}
					>
						TOTAL
					</div>
				);
			},
			width: 250,
			dataIndex: "total",
			render: (f, record) => (
				<Section style={{ alignItems: "end" }}>
					<Typo type="primary" fontWeight={700} fontSize={15}>
						$ {numberWithDotAndCommas(parseFloat(f))}
					</Typo>
					<Typo type="success" fontWeight={500} fontSize={13}>
						{record.total - record.subTotal === 0
							? ``
							: `Desc.: $ ${numberWithDotAndCommas(parseFloat((record.total - record.subTotal) * -1).toFixed(2))} `}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ESTADO
					</div>
				);
			},
			dataIndex: "state",
			render: (fila, record) => {
				let colorBackground = COLORS.LightGrey3;
				let colorText = COLORS.MediumGrey;

				switch (fila) {
					case "PROCESADA":
						colorBackground = COLORS.LightDefault;
						colorText = COLORS.Default;
						break;
					case "Pending":
						colorBackground = COLORS.LightWarning;
						colorText = COLORS.Warning;
						break;
					case "Active":
						colorBackground = COLORS.LightSecondary;
						colorText = COLORS.Secondary;
						break;
					case "Sended":
						colorBackground = COLORS.LightSuccess;
						colorText = COLORS.Success;
						break;
					case "Canceled":
						colorBackground = COLORS.LightDanger;
						colorText = COLORS.Danger;
						break;

					default:
						break;
				}

				return (
					<StateContainer>
						<ColorState colorBackground={colorBackground}>
							{record?.orderSubState ? (
								<Typo fontWeight={600} fontSize={14}>
									{record.orderSubState === "PROCESADA" && "Procesada"}
								</Typo>
							) : (
								<Typo
									fontWeight={600}
									fontSize={14}
									style={{ color: colorText }}
								>
									{fila === "Pending" && "Pendiente"}
									{fila === "Active" && "Activa"}
									{fila === "Sended" && "Enviada"}
									{fila === "Canceled" && "Cancelada"}
								</Typo>
							)}
						</ColorState>
					</StateContainer>
				);
			},
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 10,
			render: (f, r, i) => (
				<>
					<Dropdown overlay={menu} placement="bottomRight">
						<ActionButton key={`${f}`} onMouseOver={() => setKey(r)}>
							<BsThreeDotsVertical />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	if (!data) return <LoadingSkeleton />;

	return (
		<TableContainer>
			<AntdTable columns={columns} dataSource={data} loading={loading} />
			{modalInfo && (
				<Modal
					title={
						<Typo type="primary" level={4}>
							Usuario de la compra
						</Typo>
					}
					visible={isModalOpen}
					onOk={handleOk}
					onCancel={handleCancel}
				>
					<p>
						Nombre: {modalInfo?.userFirstName + " " + modalInfo?.userLastName}
					</p>
					<p>Mail: {modalInfo?.userEmail}</p>
					<p>
						Usuario de:{" "}
						{modalInfo.userFrom === "web"
							? modalInfo?.userClientName + " - Usuario Web"
							: modalInfo.userFrom === "mobile"
								? modalInfo?.userClientName + " - Usuario Mobile"
								: "Usuario One Market"}
					</p>
				</Modal>
			)}
		</TableContainer>
	);
}
